@if (_items.length > 0) {
  <section [ngClass]="{ 'is-expandable': isExpandable, expanded: expanded }">
    <h2
      class="heading-underline"
      [tabindex]="isExpandable ? 0 : -1"
      (click)="toggleExpanded()"
      (keydown.enter)="toggleExpanded()"
      (keydown.space)="toggleExpanded()"
      [title]="tooltip ? tooltip : ''"
      >
      {{ title }}
      @if (isExpandable) {
        <mat-icon fontIcon="expand_more" title="Expand/Collapse this rule" class="expand-icon"></mat-icon>
      }
    </h2>
    <div class="search-box">
      <input
        class="filterable-list-input"
        type="text"
        [placeholder]="placeholder"
        [(ngModel)]="searchText"
        (input)="onSearchInput($event)"
        (keydown)="onSearchKeyDown($event)"
        autofocus
        />
        @if (!searchText) {
          <mat-icon fontIcon="search"></mat-icon>
        }
        @if (searchText) {
          <mat-icon fontIcon="close" title="Clear search results and show all fields" (click)="clearSearch()"></mat-icon>
        }
      </div>
      <div [ngStyle]="{ display: filteredItemsCount === 0 ? 'block' : 'none' }">
        <span class="filterable-list-no-items">No items match your search</span>
      </div>
      <mat-selection-list
        [ngStyle]="{ display: filteredItemsCount !== 0 ? 'block' : 'none' }"
        #matSelectionList
        [multiple]="false"
        hideSingleSelectionIndicator
        class="scrollable-container"
        >
        @for (item of items$ | async; track item.id) {
          <mat-list-option
            [value]="item"
            [selected]="item === selectedItem"
            (click)="onItemClick(item)"
            (keydown.enter)="onItemClick(item)"
            (keydown.space)="onItemClick(item)"
            title="Click to add {{ item.label }} to the document"
            >
            <mat-icon fontIcon="chevron_left" class="add-to-document"></mat-icon>
            @if (item.icon) {
              <i class="{{ item.icon }} small-bhi"></i>
            }
            <span class="truncate-text">{{ item.label }}</span>
          </mat-list-option>
        }
      </mat-selection-list>
    </section>
  }
